import { Client, Plugin } from '@bugsnag/js';
import { getAppVersion } from '@provider-portal/common/utils/appVersion';
import { LanguageUtils } from '@provider-portal/common/utils/translations';

export const injectAppPropertiesPlugin: Plugin = {
  load: (client: Client) =>
    client.addOnError((event) => {
      const { appVersion, moduleName, moduleVersion } = getAppVersion();
      event.addMetadata('app', {
        appLocale: LanguageUtils.getAppLocaleWithFallback(),
        appVersion,
        moduleName,
        moduleVersion,
      });
    }),
};
